import {inject, Injectable} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {ConfigService} from '@shared-library';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {NGXLogger} from 'ngx-logger';

@Injectable()
export class IsAuthenticatedAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private configService: ConfigService,
    private logger: NGXLogger,
  ) {

  }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise <boolean> {
    if(this.configService.systemConfig$.searchOnly){
      return Promise.resolve(true) //skip auth check
    }

    return this.authService.GetSession()
      .then(session => {
        //check if the user is authenticated, if not, redirect to login
        if (!session) {
          if (route.url.toString() === '/auth/signin') {
            return true
          } else {
            this.logger.info("User is not authenticated, redirecting to login page")
            return this.router.navigate(['/auth/signin']);
          }
        }
        // continue as normal
        return true
      })
      .catch(err => {
        this.logger.error("error checking if user is authenticated, forcing user back to /auth/signin", err)
        return this.router.navigate(['/auth/signin']);
      })

  }
}
